/**
 * Card-keyed VCN terminate for the EMS-8827 "Associated VCNs" action bar. Mirrors
 * the EPS request/response for POST /api/v1/vcn-management/cards/terminate.
 * The client sends the card's VirtualCardKey (WEX merchant_log_id / MARQETA
 * card_public_key); EPS resolves the provider token, audit benefit id, and
 * owning employee from it.
 */
/** Max cards per card-keyed action — must match backend VCN_CARD_ACTION_MAX_CARDS. */
export const VCN_CARD_ACTION_MAX = 100

export interface VcnCardActionItem {
  provider: string
  virtualCardKey: string
}

export interface VcnCardActionRequest {
  cards: VcnCardActionItem[]
}

export interface VcnCardActionItemResult {
  provider: string
  virtualCardKey: string
  success: boolean
  errorMessage?: string
}

export interface VcnCardActionResponse {
  results: VcnCardActionItemResult[]
  successCount: number
  failedCount: number
}
